import React from 'react';
import { ToolButton } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';

const CollapseAllIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.41 18.59L8.83 20L12 16.83L15.17 20L16.59 18.59L12 14L7.41 18.59ZM16.59 5.41L15.17 4L12 7.17L8.83 4L7.41 5.41L12 10L16.59 5.41Z"
      fill="currentColor"
    />
  </svg>
);

const ExpandAllIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 5.83L15.17 9L16.58 7.59L12 3L7.41 7.59L8.83 9L12 5.83ZM12 18.17L8.83 15L7.42 16.41L12 21L16.59 16.41L15.17 15L12 18.17Z"
      fill="currentColor"
    />
  </svg>
);

export const CollapseExpandButton: React.FC<{
  isAllCollapsed: boolean;
  onToggle: () => void;
}> = ({ isAllCollapsed, onToggle }) => {
  const t = useTranslations();

  return (
    <ToolButton
      size="sm"
      isShowTooltip
      tooltipNode={
        isAllCollapsed
          ? t('Editor.inspector.expand-all')
          : t('Editor.inspector.collapse-all')
      }
      onClick={onToggle}
    >
      {isAllCollapsed ? <ExpandAllIcon /> : <CollapseAllIcon />}
    </ToolButton>
  );
};
